<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="server_title"
        class="form-control-label">{{$t('views.server.form.title')}}</label>
      <input
        id="server_title"
        v-model="item.title"
        :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('title', $event.target.value)">
      <div
        v-if="isInvalid('title')"
        class="invalid-feedback">{{ violations.title }}</div>
    </div>
    <div class="form-group">
      <label
        for="server_host"
        class="form-control-label">{{$t('views.server.form.host')}}</label>
      <input
        id="server_host"
        v-model="item.host"
        :class="['form-control', isInvalid('host') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('host', $event.target.value)">
      <div
        v-if="isInvalid('host')"
        class="invalid-feedback">{{ violations.host }}</div>
    </div>
    <div class="form-group">
      <label
        for="server_port"
        class="form-control-label">{{$t('views.server.form.port')}}</label>
      <input
        id="server_port"
        v-model="item.port"
        :class="['form-control', isInvalid('port') ? 'is-invalid' : '']"
        type="number"
        required="true"
        placeholder=""
        @input="handleUpdateField('port', $event.target.value)">
      <div
        v-if="isInvalid('port')"
        class="invalid-feedback">{{ violations.port }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">{{$t('buttons.submit')}}</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
